module.exports = __webpack_public_path__ + "img/gebratenesrindfleischohnehintergrund.be455dd7.png";